<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
          <div class="card bg-white shadow-sm rounded-5 border-0">
            <div class="card-header bg-white rounded-5 border-0">
                <div class="card-header border-0 bg-white rounded-5 d-flex justify-content-between align-items-center">
                    <!-- <span class="fw-500">Manage Questions</span> -->
                   <button
                      class="btn btn-warning text-white text-xxs rounded-5 shadow-lg fw-500"
                      @click="assign_selected()"
                      :disabled="selectedQuestions.length === 0"
                      :aria-disabled="selectedQuestions.length === 0"
                      :title="selectedQuestions.length === 0 ? 'Select at least one question' : 'Assign selected questions'"
                    >
                      <i class='bx bx-plus'></i> Assign Questions
                    </button>

                  </div>

                <table id="questionsTable"class="table table-striped text-xxs mt-3">
                    <thead class="btn-primary text-white">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Question</th>
                    <th scope="col">Type</th>
                    <th scope="col">Choice</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody class="text-black">
                  <tr v-for="(question, index) in questionDetails" :key="question.question_id">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ question.question_name }}</td>
                    <td>{{ question.question_type }}</td>
                    <td>
                    </td>
                    <td>
                        <input
                        class="form-check-input ms-3"
                        type="checkbox"
                        :id="'question_check_' + question.question_id"
                        :value="question.question_id"
                        v-model="selectedQuestions"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>